import React from "react"
import { useHelper } from "../HelperContext"
import { Field } from "../components"

const setValue = (elem, value) => {
  if (elem) {
    // Get the native value setter for React controlled inputs
    const nativeInputValueSetter = Object.getOwnPropertyDescriptor(
      window.HTMLInputElement.prototype,
      'value'
    ).set

    // Set the value using the native setter
    nativeInputValueSetter.call(elem, value)

    // Trigger input event to notify React
    const inputEvent = new Event('input', { bubbles: true })
    elem.dispatchEvent(inputEvent)
  }
}

export const CngField = ({ name, ...props }) => {
  const { cngRef } = useHelper()

  const handleInputChange = (event) => {
    const value = event.target.value
    const oldElem = cngRef?.current?.querySelector(`input[name="${name}"]`)
    setValue(oldElem, value)
  }

  return <Field {...props} name={name}
    onChange={handleInputChange}
  />
}